import { Component, OnInit } from '@angular/core';
import { ToolsService } from 'src/app/services/tools/tools.service';

@Component({
  selector: 'app-footer-client',
  templateUrl: './footer-client.component.html',
  styleUrls: ['./footer-client.component.css']
})
export class FooterClientComponent implements OnInit {
  domainUser:any;
  constructor(
    private tools: ToolsService,
  ) { }

  ngOnInit() {
    this.domainUser=this.tools.getStor("domainUser")?this.tools.getStor("domainUser"):null;
  }

 

  goTerms(): void {
    
    const merchantName:any = this.tools.getStor("url_encode");
    const pointOfSale:any = this.tools.getStor("point_of_sale");
    window.open(window.location.origin + "/merchantTerms" + "/" + merchantName + "/" + pointOfSale.id_webshop, "_blank");
  
  }

 /**
   * @description Redirige vers le site de fulle
   */
 goFulle(): void {
  window.open("https://fulleapps.com/");
}

}
